import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { COUNTRIES } from "@/lib/circle";

export default function CountrySelect({ value, onChange, id }) {
    const [open, setOpen] = useState(false);
    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <button id={id} type="button" role="combobox" aria-expanded={open} data-testid="ic-country"
                        className="editorial-input flex items-center justify-between text-left">
                    <span className={value ? "" : "text-muted_text"}>{value || "Select your country"}</span>
                    <ChevronDown className="h-4 w-4 text-muted_text shrink-0" />
                </button>
            </PopoverTrigger>
            <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] bg-cream border-hairline" align="start">
                <Command>
                    <CommandInput placeholder="Search country…" data-testid="ic-country-search" />
                    <CommandList className="max-h-64">
                        <CommandEmpty>No country found.</CommandEmpty>
                        <CommandGroup>
                            {COUNTRIES.map((c) => (
                                <CommandItem key={c} value={c} onSelect={() => { onChange(c); setOpen(false); }} data-testid={`ic-country-option-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                                    <Check className={`mr-2 h-4 w-4 ${value === c ? "opacity-100" : "opacity-0"}`} />{c}
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
